import { FormEvent, useState } from 'react';
import BookingAccountLayout from 'pages/booking/account/BookingAccountLayout';
import { useApi } from 'api/api-context';
import useLang from 'lang';
import 'pages/booking/booking-auth-form.css';

/** Let a signed-in booking guest change their password. */
export default function AccountPassword() {
  const { request } = useApi();
  const { _t } = useLang();
  const [currentPassword, setCurrentPassword] = useState('');
  const [token, setToken] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  /** Verify the current password and send a confirmation code. */
  const begin = async (event: FormEvent) => {
    event.preventDefault();
    setError('');
    try {
      const response = await request<{ token: string }>({
        method: 'POST',
        url: '/change-password/request',
        data: { password: currentPassword },
      });
      setToken(response.token);
      setMessage(_t('A confirmation code was sent to your email.'));
    } catch {
      setError(_t('The current password is incorrect.'));
    }
  };
  /** Apply the new password after confirmation. */
  const finish = async (event: FormEvent) => {
    event.preventDefault();
    setError('');
    try {
      await request({ method: 'POST', url: '/change-password', data: { token, code, password } });
      setMessage(_t('Your password has been changed.'));
      setToken('');
      setCurrentPassword('');
      setCode('');
      setPassword('');
    } catch {
      setError(_t('The code is invalid or expired.'));
    }
  };

  return (
    <BookingAccountLayout>
      <div className="booking-auth-card">
        <h2>{_t('Change password')}</h2>
        {!token ? (
          <form onSubmit={begin}>
            <label>
              {_t('Current password')}
              <input
                required
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </label>
            <button>{_t('Send confirmation code')}</button>
          </form>
        ) : (
          <form onSubmit={finish}>
            <label>
              {_t('Code')}
              <input required value={code} onChange={(e) => setCode(e.target.value)} />
            </label>
            <label>
              {_t('New password')}
              <input
                required
                minLength={8}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            <button>{_t('Change password')}</button>
          </form>
        )}
        {message && <p role="status">{message}</p>}
        {error && (
          <p className="booking-auth-error" role="alert">
            {error}
          </p>
        )}
      </div>
    </BookingAccountLayout>
  );
}
